export enum EmployeesCountFilterOptions {
  Few = 'few',
  Some = 'some',
  Several = 'several',
  Many = 'many',
  Zero = 'zero',
  Unknown = 'unknown',
}

export enum GeneralFilterOptions {
  All = 'all',
  Feedback = 'feedback',
  Recommended = 'recommended',
  Unknown = 'mine-unknown-custom',
}

export enum OriginFilterOptions {
  Email = 'Email',
  Sso = 'Sso',
  Cloud = 'Cloud',
  Website = 'Website',
  OnlyEmail = 'OnlyEmail',
}

export enum CategoriesFilterOptions {
  Analytics = 'Analytics',
  CollaborationProductivity = 'CollaborationProductivity',
  Communications = 'Communications',
  CustomerService = 'CustomerService',
  DataInfrastructure = 'DataInfrastructure',
  Development = 'Development',
  Ecommerce = 'Ecommerce',
  ArtificialIntelligence = 'ArtificialIntelligence',
  Finance = 'Finance',
  GovernanceLegal = 'GovernanceLegal',
  HealthWellnessFitness = 'HealthWellnessFitness',
  HR = 'HR',
  IT = 'IT',
  Marketing = 'Marketing',
  Operations = 'Operations',
  Sales = 'Sales',
  Security = 'Security',
  SocialMedia = 'SocialMedia',
  Travel = 'Travel'
}

export enum LastLoginFilterOptions {
  Last7Days = 'last7Days',
  Last30Days = 'last30Days',
  Last60Days = 'last60Days',
  Over60Days = 'over60Days',
}

export enum RadarFilterGroups {
  Usage = 'usage',
  EmployeesCount = 'employeesCount',
  Category = 'Category',
  General = 'general',
  Origin = 'origin',
  LastLogin = 'lastLogin',
}